<template>
  <BaseDialog
    v-model="showDialog"
    :title="title"
    :subtitle="subtitle"
    btnActionName="Last ned bilde"
    maxWidth="1000"
    :width="null"
    @action="download"
    @close="close"
  >
    <template v-slot>
      <v-carousel
        v-if="showDialog"
        v-model="imageShown"
        @change="changeImg"
        hide-delimiter-background
      >
        <v-carousel-item
          class="carousel"
          v-for="(item, i) in images"
          :key="i"
          :src="item.src"
        ></v-carousel-item>
      </v-carousel>
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";
import { saveFile } from "@/helpers/files";
import blobApi from "@/api/blobApi";

import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";

var reader = new FileReader();

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    subtitle: {
      type: String,
    },
    text: {
      type: String,
    },
    images: {
      type: Array as () => Array<any>,
      required: true,
    },
  },
  data() {
    return {
      imageShown: null,
      urlTest: "",
      title: "",
    };
  },
  methods: {
    close() {
      this.imageShown = null;
    },
    async changeImg(index) {
      if (!this.images[index].url) {
        var url = await this.loadImg(this.images[index]);
        this.$set(this.images[index], "src", url);
      }
      this.title = this.images[index].name || this.images[index].fileName;
    },

    async loadImg(file) {
      if (file) {
        if (file.url) {
          return;
        }
        var haveData = file.blob !== undefined;
        var noBlob = file.base64 == "";
        if (!haveData && noBlob) {
          return await blobApi.downloadBlob(file).then(async (response) => {
            file.blob = response.blob;
            return await this.readImg(file);
          });
        } else {
          if (file.base64) {
            file.url = "data:" + file.contentType + ";base64," + file.base64;
          } else {
            return await this.readImg(file);
          }
        }
      }
    },
    readImg(file) {
      return new Promise((resolve) => {
        reader.readAsDataURL(file.blob);
        reader.onload = function () {
          resolve(reader.result);
        };
      });
    },
    download() {
      if (this.imageShown !== null) {
        var index = this.imageShown as any;
        saveFile(this.images[index]);
      }
    },
  },
  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },
  components: {
    BaseDialog,
  },
});
</script>

<style lang="scss">
.carousel {
  .v-image__image--cover {
    background-size: contain !important;
  }
}
</style>
